import { Entity } from "@common/types/entity";
import { formatISO } from "date-fns";
import { exportTrialBalance } from "@api/accountingReports.api";
import { AccountingReportFilters } from "@components/accounting/types";
import { ReportFormat } from "@common/helpers/reports";
import {
    AccountingReportType,
    ACCOUNTING_REPORT_LABELS,
} from "@common/types/reports/report-type";
import { saveBlobResponse, useFileDownload } from "@lib/fileDownload";
import { ReportSettingRowVisibility } from "@common/types/reports/report-settings";
import { pickXlsxExportRowVisibility } from "@components/accounting/xlsxExportRowVisibility";

interface TrialBalanceDownloadParams {
    entity: Entity;
    format: ReportFormat;
    date?: Date;
}

export function useTrialBalanceDownload(
    requestDto: AccountingReportFilters,
    rowVisibility?: ReportSettingRowVisibility,
) {
    return useFileDownload(
        async ({ entity, format, date }: TrialBalanceDownloadParams) => {
            if (!requestDto) {
                return;
            }

            const modifiedRequestDto = {
                ...requestDto,
                format,
            };

            const exportRowVisibility = pickXlsxExportRowVisibility(
                format,
                rowVisibility,
            );

            const response = await exportTrialBalance(
                modifiedRequestDto,
                exportRowVisibility,
            );

            if (!response) {
                return;
            }

            const reportTypeTitle =
                ACCOUNTING_REPORT_LABELS[AccountingReportType.TRIAL_BALANCE];
            const fileName = `${entity.name} - ${reportTypeTitle} - ${date ? formatISO(date, { representation: "date" }) : ""}.${format}`;

            saveBlobResponse(response, fileName);
        },
    );
}
